import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'delta', 'Delta', [["path",{"d":"M4 20h16l-8 -16l-8 16","key":"svg-0"}]]);